// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enterprise-dashboard .card {
  border-radius: 24px;
  border: none;
}
.enterprise-dashboard .card-title-wrapper {
  margin-bottom: 1.5rem;
}
.enterprise-dashboard .btn {
  width: auto;
  background-color: rgba(127, 176, 54, 0.1803921569);
  padding: 5px;
  border-radius: 15px;
  box-sizing: border-box;
  margin-top: 4px;
  margin-right: 20px;
  color: #80b036;
  font-size: 14px;
  font-weight: unset;
}
.enterprise-dashboard .title {
  font-size: 24px;
  font-weight: 500;
}
.enterprise-dashboard .sub-card .card {
  height: 100px;
  width: 140px;
  cursor: pointer;
}
.enterprise-dashboard .sub-card .card-body {
  position: relative;
}
.enterprise-dashboard .sub-card p {
  position: absolute;
  margin-bottom: 0rem;
  font-size: 14px;
  bottom: 1rem;
  line-height: 1rem;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
  /* Set your desired max-width */
}

.ownership .ownership_heading {
  font-family: Inter;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: -0.02em;
  text-align: left;
  color: #3a7425;
}
.ownership .add_button {
  width: Fixed 138px;
  height: Fixed 48px;
  border-radius: 8px;
  background: #45852e;
  border: 2px solid #45852e;
}

.controlling_ownership .controlling_ownership_heading {
  font-family: Inter;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: -0.02em;
  text-align: left;
  color: #3a7425;
  margin-top: 16px;
}
.controlling_ownership .controlling_ownership_button {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0px;
  background: linear-gradient(0deg, rgba(69, 133, 46, 0.1), rgba(69, 133, 46, 0.1));
  border: 1px dashed #45852e;
}

.welcome_notes {
  background: linear-gradient(0deg, #f7eaea, #f7eaea);
  border: 0.74px solid #c44744;
}

.ownership_row {
  margin-left: -15px;
  margin-right: -15px;
}

.ownership_table_header {
  padding: 1rem 0 1rem 1rem;
  display: flex;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom: 1px solid #ebebeb;
  background: #e2f0df;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
}

.table_outer_area {
  display: block;
  width: 100%;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.0784313725);
}

.table_header_part {
  width: 100%;
  background: #45852e;
  border-radius: 16px 16px 0px 0px;
  display: table;
}
.table_header_part tr th {
  color: white;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17.6px;
  letter-spacing: -0.02em;
  padding: 5px 0;
  text-align: center;
  z-index: 0;
}

.table_body_part {
  width: 100%;
  display: table;
}
.table_body_part tr {
  border-top: 1px solid rgba(51, 51, 51, 0.0784313725);
}
.table_body_part tr .tabel_data {
  font-family: Karla;
  font-size: 16px;
  font-weight: 400;
  line-height: 17.6px;
  letter-spacing: -0.02em;
  color: #404040;
  padding-top: 16px;
  text-align: center;
}

.table_footer_part {
  width: 100%;
  background: #45842e;
  border-top: 1px solid rgba(0, 0, 0, 0.0784313725);
  border-radius: 0px 0px 16px 16px;
}
.table_footer_part p {
  font-family: Karla;
  font-size: 16px;
  font-weight: 400;
  line-height: 17.6px;
  letter-spacing: -0.02em;
  color: #fff;
  margin: 0;
}

.fixed-action-column {
  position: sticky;
  right: 0;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 99;
  width: 180px;
  background-color: white;
  margin-top: -16px;
  margin-bottom: -16px;
  padding: 30px !important;
}

.fixed-action-column-bg {
  background-color: #3a7425;
}

.table-actions {
  display: flex;
  gap: 15px;
}

.table-action-icon {
  cursor: pointer;
}

.navigateStyle {
  color: #3370d4 !important;
  cursor: pointer;
}

.documentStyle {
  color: #3370d4 !important;
  cursor: pointer;
}

.pendency {
  width: 12.5%;
}

.application-number {
  width: 20.8%;
}

.width-fit-cont {
  width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/features/modules/UserManagement/EnterpriseModule/EnterpriseStyles.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,YAAA;AAAR;AAGI;EACI,qBAAA;AADR;AAII;EACI,WAAA;EACA,kDAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAFR;AAKI;EACI,eAAA;EACA,gBAAA;AAHR;AAOQ;EACI,aAAA;EACA,YAAA;EACA,eAAA;AALZ;AAQQ;EACI,kBAAA;AANZ;AASQ;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAPZ;;AAaA;EACI,gBAAA;EAEA,uBAAA;EACA,cAAA;EACA,+BAAA;AAXJ;;AAeI;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAZR;AAeI;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAbR;;AAkBI;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAfR;AAkBI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iFAAA;EACA,0BAAA;AAhBR;;AAoBA;EACI,mDAAA;EACA,4BAAA;AAjBJ;;AAsBA;EACI,kBAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,yBAAA;EACA,aAAA;EACA,4BAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAnBJ;;AAqBA;EACI,cAAA;EACA,WAAA;EACA,mBAAA;EACA,6CAAA;AAlBJ;;AAoBA;EACI,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;AAjBJ;AAmBQ;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAjBZ;;AAqBA;EACI,WAAA;EACA,cAAA;AAlBJ;AAmBI;EACI,oDAAA;AAjBR;AAkBQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAhBZ;;AAoBA;EACI,WAAA;EACA,mBAAA;EACA,iDAAA;EACA,gCAAA;AAjBJ;AAmBI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;AAjBR;;AAqBA;EACI,gBAAA;EACA,QAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;AAlBJ;;AAqBA;EACI,yBAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,SAAA;AAlBJ;;AAqBA;EACI,eAAA;AAlBJ;;AAqBA;EACI,yBAAA;EACA,eAAA;AAlBJ;;AAoBA;EACI,yBAAA;EACA,eAAA;AAjBJ;;AAsCA;EACI,YAAA;AAnCJ;;AAsCA;EACI,YAAA;AAnCJ;;AAqCA;EACI,kBAAA;AAlCJ","sourcesContent":[".enterprise-dashboard {\n    .card {\n        border-radius: 24px;\n        border: none;\n    }\n\n    .card-title-wrapper {\n        margin-bottom: 1.5rem;\n    }\n\n    .btn {\n        width: auto;\n        background-color: #7fb0362e;\n        padding: 5px;\n        border-radius: 15px;\n        box-sizing: border-box;\n        margin-top: 4px;\n        margin-right: 20px;\n        color: #80b036;\n        font-size: 14px;\n        font-weight: unset;\n    }\n\n    .title {\n        font-size: 24px;\n        font-weight: 500;\n    }\n\n    .sub-card {\n        .card {\n            height: 100px;\n            width: 140px;\n            cursor: pointer;\n        }\n\n        .card-body {\n            position: relative;\n        }\n\n        p {\n            position: absolute;\n            margin-bottom: 0rem;\n            font-size: 14px;\n            bottom: 1rem;\n            line-height: 1rem;\n            // width: 75%;\n        }\n    }\n}\n\n.truncate {\n    overflow: hidden;\n    // white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 80%;\n    /* Set your desired max-width */\n}\n\n.ownership {\n    .ownership_heading {\n        font-family: Inter;\n        font-size: 1.25rem;\n        font-weight: 500;\n        letter-spacing: -0.02em;\n        text-align: left;\n        color: #3a7425;\n    }\n\n    .add_button {\n        width: Fixed (138px);\n        height: Fixed (48px);\n        border-radius: 8px;\n        background: #45852e;\n        border: 2px solid #45852e;\n    }\n}\n\n.controlling_ownership {\n    .controlling_ownership_heading {\n        font-family: Inter;\n        font-size: 1.25rem;\n        font-weight: 500;\n        letter-spacing: -0.02em;\n        text-align: left;\n        color: #3a7425;\n        margin-top: 16px;\n    }\n\n    .controlling_ownership_button {\n        font-family: Inter;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 26px;\n        letter-spacing: 0px;\n        background: linear-gradient(0deg, rgba(69, 133, 46, 0.1), rgba(69, 133, 46, 0.1));\n        border: 1px dashed #45852e;\n    }\n}\n\n.welcome_notes {\n    background: linear-gradient(0deg, #f7eaea, #f7eaea);\n    border: 0.74px solid #c44744;\n}\n\n//Cuatom ownership tables\n\n.ownership_row {\n    margin-left: -15px;\n    margin-right: -15px;\n}\n\n.ownership_table_header {\n    padding: 1rem 0 1rem 1rem;\n    display: flex;\n    border-top-left-radius: 24px;\n    border-top-right-radius: 24px;\n    border-bottom: 1px solid #ebebeb;\n    background: #e2f0df;\n    text-align: center;\n    width: 100%;\n    border-collapse: collapse;\n}\n.table_outer_area {\n    display: block;\n    width: 100%;\n    border-radius: 16px;\n    border: 1px solid #00000014;\n}\n.table_header_part {\n    width: 100%;\n    background: #45852e;\n    border-radius: 16px 16px 0px 0px;\n    display: table;\n    tr {\n        th {\n            color: white;\n            font-family: Inter;\n            font-size: 14px;\n            font-weight: 500;\n            line-height: 17.6px;\n            letter-spacing: -0.02em;\n            padding: 5px 0;\n            text-align: center;\n            z-index: 0;\n        }\n    }\n}\n.table_body_part {\n    width: 100%;\n    display: table;\n    tr {\n        border-top: 1px solid #33333314;\n        .tabel_data {\n            font-family: Karla;\n            font-size: 16px;\n            font-weight: 400;\n            line-height: 17.6px;\n            letter-spacing: -0.02em;\n            color: #404040;\n            padding-top: 16px;\n            text-align: center;\n        }\n    }\n}\n.table_footer_part {\n    width: 100%;\n    background: #45842e;\n    border-top: 1px solid #00000014;\n    border-radius: 0px 0px 16px 16px;\n\n    p {\n        font-family: Karla;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 17.6px;\n        letter-spacing: -0.02em;\n        color: #fff;\n        margin: 0;\n    }\n}\n\n.fixed-action-column {\n    position: sticky;\n    right: 0;\n    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);\n    z-index: 99;\n    width: 180px;\n    background-color: white;\n    margin-top: -16px;\n    margin-bottom: -16px;\n    padding: 30px !important;\n}\n\n.fixed-action-column-bg {\n    background-color: #3a7425;\n}\n\n.table-actions {\n    display: flex;\n    gap: 15px;\n}\n\n.table-action-icon {\n    cursor: pointer;\n}\n\n.navigateStyle {\n    color: #3370d4 !important;\n    cursor: pointer;\n}\n.documentStyle {\n    color: #3370d4 !important;\n    cursor: pointer;\n}\n\n// .ownership_table_container {\n//     width: 100%;\n//     overflow-x: auto;\n// }\n// .ownership_table {\n//     width: 100%;\n//     border-collapse: collapse;\n// }\n// .ownership_thead {\n//     background-color: #e2f0df;\n// }\n// .ownership_th {\n//     padding: 10px;\n// }\n// .ownership_td {\n//     padding: 10px;\n// }\n\n.pendency {\n    width: 12.5%;\n}\n\n.application-number {\n    width: 20.8%;\n}\n.width-fit-cont {\n    width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
